export default {
  parameters: {
    landing_id: "TreMt",
  },
  downtimeUrl: "https://www.kodland.org/tr",
  startPage: {
    startBackground: "#D6FF6B",
    quizBackground: "#white",
    title:
      "<div><b>3 soruyu yanıtlayın ve ÜCRETSİZ eğlenceli bir matematik dersi alın</div></b>",
    subtitle:
      "Bir oyun aracılığıyla matematik öğrenimin anlatılacak. Bilgi düzeyiniz belirlenecek. Matematik becerilerini nasıl geliştirebileceğiniz gösterilecek.",
    image: {
      url: "/welcome/quiz_turkey_math_active_v2_pk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    button: {
      text: "Ücretsiz ders almak için tıklayın",
      style: {
        background: "#5988FF",
        color: "#FFFFFF",
        "font-weight": "bold",
      },
    },
    imageMobile: {
      url: "/welcome/quiz_turkey_math_active_v2_mb.png",
      style: {
        width: "100%",
      },
    },
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title:
      "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Çocuğun matematik, mantık veya aritmetik öğrenme deneyimi var mı?",
      subtitle:
        "Kadın öğretmen: Çocuğunuza matematiği nasıl öğreteceğinizi öğrenin",
      answers: [
        {
          answer: "🏫 Evet, okulda eğitim aldı",
          distribution_tag_question: [48],
        },
        {
          answer: "🧒 Evet, kendi başına veya ebeveynlerle eğitim aldı",
          distribution_tag_question: [48],
        },
        {
          answer: "👩‍🎓 Evet, kurslarda/çocuk branşlarında eğitim aldı",
          distribution_tag_question: [48],
        },
        {
          answer: "😊 Hayır, deneyimi yok",
          distribution_tag_question: [48],
        },
      ],
    },
    2: {
      question: "Çocuğunuz daha önce online ders aldı mı?",
      answers: [
        "✅ Evet, düzenli aldı",
        "🙂 Evet, kısa süreli aldı",
        "😌 Hayır, hiç almadı",
      ],
    },
    3: {
      question: "Çocuğunuzun eğitimi için aylık hangi bütçe uygundur?",
      financial: true,
      answers: [
        "💵 ₺1.000’e kadar",
        "💳 ₺1.000–2.000",
        "💰 ₺2.000–3.500",
        "🤑 ₺3.500 üzeri",
      ],
    },
    4: {
      question:
        "Çocuğunuzun ders dışı aktivitelerine aylık ne kadar harcıyordunuz?",
      answers: [
        "🚫 Harcama yapmadım",
        "💵 ₺500–1.500",
        "💳 ₺1.500–3.000",
        "💰 ₺3.000’den fazla",
      ],
    },
    5: {
      question:
        "Çocuğunuza deneme matematik dersi önerirseniz nasıl tepki verir?",
      answers: [
        "🤩 İlgi gösterir",
        "🤔 Kararsız ama dener",
        "⚽ Başka aktiviteleri tercih eder",
        "❌ İstemediğini söyler",
      ],
    },
    6: {
      title: "Deneme dersi için hangi saatte uygunsunuz?",
      type: "timeslot",
      subtitle:
        "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
      button: "Rezervasyon için tıklayın 🎁",
    },
    7: {
      title: "Çocuğunuz kaç yaşında?",
      type: "age",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz",
      button: "İleri 🚀",
      featureParameter: "a_math5_7",
    },
    8: {
      title: "İsminizi girin",
      type: "parent_name",
      subtitle: "Bizim adımız Kodland, sizinki ne?👋",
      button: "İleri 🚀",
    },
    9: {
      title: "E-postanızı girin",
      type: "mail",
      subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
      button: "İleri 🚀",
    },
    10: {
      title: "Telefon numaranızı girin",
      type: "phone",
      subtitle:
        "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
      button: "Neredeyse bitti 🔥",
    },
    11: {
      question:
        "Ücretsiz derse katılmak için çocuğunuzun bilgisayar veya dizüstü bilgisayar (telefon değil) ve sabit internet bağlantısı olması gerekir. Evinizde bilgisayar/dizüstü bilgisayar var mı?",
      answers: [
        {
          answer: "💻 Evet, evimizde var",
          distribution_tag_question: [18],
        },
        {
          answer: "❌ Hayır, evimizde yok",
          stopAnswer: true,
        },
      ],
    },
    12: {
      title: "Çocuğunuzun adı nedir?",
      type: "child_name",
      subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir🚨",
      button: "Son adım! 🎉",
    },
  },
};
